module.exports = __webpack_public_path__ + "static/btn-yes-6c9c5ce3713b8793266cdc3c62bb2b2d.png";